export enum FiChatSourceMessageType {
    Reply = 0,
    Forwarded = 1,
}
